import React from "react";
import "../sobre-historico/sobre-historico-style.css";
import SobreHistoricoMes from "../sobre-historico-mes";

function InformacoesConsultaHistoricoMes(props) {
  return (
    <>
        {props.mostrar ? (<SobreHistoricoMes data={props.data}/>): ''}
    </>
  );
}

export default InformacoesConsultaHistoricoMes;
